import { InjectionToken } from "@angular/core";

export const KONTRAKT_FILTER_KEY = new InjectionToken<string>("Kontrakt token filter key");

export const KONTRAKT_SEARCH_KEY = new InjectionToken<string>("Kontrakt token search key");
